import { generateCompanyFilters } from './companyFilters';
import { generateValueFilters } from './valueFilters';
import { generateFuturePerformanceFilters } from './futurePerformance';
import { generatePastFilters } from './pastFilters';
import { generateHealthFilters } from './healthFilters';
import { generateDividendsFilters } from './dividendsFilter';
import { generateManagementFilters } from './managementFilters';
import { generateOtherFilters } from './otherFilters';
import type { CustomCompanyFilter } from './types';

export const filterGroups: {
  label: string;
  filters: CustomCompanyFilter[];
}[] = [
  { label: 'Company', filters: generateCompanyFilters() },
  { label: 'Valuation', filters: generateValueFilters() },
  {
    label: 'Future Growth Estimate',
    filters: generateFuturePerformanceFilters(),
  },
  { label: 'Past Performance', filters: generatePastFilters() },
  { label: 'Financial Health', filters: generateHealthFilters() },
  { label: 'Dividends', filters: generateDividendsFilters() },
  { label: 'Management', filters: generateManagementFilters() },
  { label: 'Other', filters: generateOtherFilters() },
];
